import React, { Suspense, lazy } from 'react';
import ReactToolip from 'react-tooltip';
import Select from 'react-select';
import { commaSeperatedAmount, CURRENCY_SYMBOL, scrollTo, selectedStyles } from '../../common';
import Type from './type';
import { Redirect, withRouter } from 'react-router-dom';
import { Common } from '../../common/common';
import { config, MAX_OXPAY_ACCEPTANCE_AMOUNT } from '../../common/constant';
import { PayNow } from '../../jwt/_services/paynow-service';
import { minimumAmount } from '../../common/constant';
import { connect } from 'react-redux';
import * as user from '../../redux/actions/userAction';
import * as zakat from '../../redux/actions/zakatActions';
import * as zakatCalc from '../../redux/actions/zakatCalcAction';
import FlickeringTypeOfZakat from './flickering/flickering-type-of-zakat';
import Loader from '../../views/MUIS/loader';
import PopupSwitchBusinessIndividual from '../../views/pop-up/popup-switch-business-individual';
import loginPool from '../../aws-pool/login-pool';
import { Form, Formik } from 'formik';
import NumberFormat from 'react-number-format';
import { withTranslation } from "react-i18next";
import i18n from "i18next";
import { MARK_EXCLAMATION_GREY_17x17 } from '../../common/images-s3';
import { isEqual } from 'lodash';
import { ACCORDION_BOTTOM, ACCORDION_TOP } from '../../common/images-svg';
import Footer from '../footer/footer';
import moment from 'moment';
import { questionnAireHeaderData } from '../../component/contribution-type';

const ImageLoader = lazy(() => import('../../common/image-loader'));


export const enrollmentMethodHeaderData = {
    title: 'Enrolment Method',
    subTitle: 'Next - Enrolment Details',
    steps: 5
}

class TypeOfZakat extends React.Component {
    _isMounted = false;

    constructor(props) {
        super(props);

        this.state = {
            configData: null,
            types: [],
            amt: 0,
            reloadToSummary: false,
            isBtnDisabled: parseFloat(this.props.zakat.totalAmount) > 0 ? false : true,
            totalAmt: this.props.zakat.totalAmount ?? 0,
            sourceList: [
                this.props.zakat.business,
                this.props.zakat.gold,
                this.props.zakat.insurance,
                this.props.zakat.savings,
                this.props.zakat.shares,
            ],
            fitrah: [
                this.props.zakat.zakatfitrah
            ],
            isError: false,
            popupDetails: {
                "popupHeading": 'errorMessage',
                "userEmail": "",
                "popupSubHeading": "Something went wrong",
                "isButtonVisible": true,
                "isLoginButton": false,
                "buttonText": "Try Again"
            },
            isPopupSwitchBusinessIndividual: false,
            popupSwitchBusinessIndividual: {
                "title": 'Switching to Business will clear all existing data',
            },
            reduxStore: this.props.zakat ?? {},
            fitrahData: this.props.homepage.muisZakatFitrah,
            taxDeductionText: this.props.homepage.muisZakatHarta?.taxDeductionText ?? '',
            todayNisabValue: this.props.homepage.muisZakatHarta?.nisab?.value ?? '',
            zakatId: this.props.homepage.muisZakatHarta?.id ?? 0,
            fitrahId: this.props.homepage.muisZakatFitrah?.id ?? 0,
            userData: this.props.user ?? null,
            isIRASAutoInclusionScheme: this.props.user.hasIRASInclusion === null ? true : false,
            isLoading: false,
            isBusinessPayer: this.props.user.isBusinessPayer ?? false,
            sourceOfIncome: true,
            sourceOfIncomeList: [],
            renderIncomeError: false,
            sourceOfIncomeSelected: { 'label': 'Select source of income', 'value': 'Select source of income' },
            variableRate: this.props.zakat.zakatfitrah.type.variable.rate > 0 ? this.props.zakat.zakatfitrah.type.variable.rate : '',
            variableNoOfPeople: this.props.zakat.zakatfitrah.type.variable.noOfPerson > 0 ? this.props.zakat.zakatfitrah.type.variable.noOfPerson : '',
            fitrahOpen: true,
            hartaOpen: true,
       
        }

        this.getTypes = this.getTypes.bind(this);
        this.closePopUP = this.closePopUP.bind(this);
        this.setSources = this.setSources.bind(this);
        this.updateContext = this.updateContext.bind(this);
        this.setFitrahData = this.setFitrahData.bind(this);
        this.closeIRASPopup = this.closeIRASPopup.bind(this);
        this.updateFitrahData = this.updateFitrahData.bind(this);
        this.sourceOfIncomeUpdate = this.sourceOfIncomeUpdate.bind(this);
        this.shouldTriggerDisable = this.shouldTriggerDisable.bind(this);
        this.setIRASAautoInclusion = this.setIRASAautoInclusion.bind(this);
        this.toggleBusinessIndividual = this.toggleBusinessIndividual.bind(this);
        this.handleCloseBusinessIndividual = this.handleCloseBusinessIndividual.bind(this);
        this.handleOkayBusinessIndividual = this.handleOkayBusinessIndividual.bind(this);
        this.handleNext = this.handleNext.bind(this);
        this.handleSkip = this.handleSkip.bind(this);
        // this.controller = new AbortController();
        this.inputRefs = [];
    }

    handleCloseBusinessIndividual() {
        this.setState({ isPopupSwitchBusinessIndividual: false });
    }

    handleOkayBusinessIndividual() {

        // it says it will clear all the data
        const isBusinessPayer = !this.state.isBusinessPayer;
        const isIRASAutoInclusionScheme = isBusinessPayer ? false : true;

        this.setState({ isBusinessPayer, isIRASAutoInclusionScheme }, () => setTimeout(() => this.setSources(), 0));

        const dataObject = {
            rate: 0,
            noOfPerson: 0,
            amount: 0
        };

        this.props.dispatch(zakat.updateZakatFitrahData('variable', dataObject));

        this.props.dispatch(user.updateBusinessUser(isBusinessPayer));
        this.props.dispatch(user.updateIRASInclusion(isIRASAutoInclusionScheme));
        this.props.dispatch(zakat.resetZakatData());
        this.props.dispatch(zakatCalc.resetFitrahData());
        this.props.dispatch(zakatCalc.resetZakatCalcData());
        this.props.dispatch(zakatCalc.updateNisabValue(this.props?.homepage?.muisZakatHarta?.nisab?.value));

        if (!isBusinessPayer) {
            this.props.dispatch(user.updateUserSteps(questionnAireHeaderData));
            this.props.dispatch(zakat.resetZakatData());
            this.props.dispatch(zakat.resetFitrahData());
            this.props.dispatch(user.updateBusinessUser(null));
            this.props.dispatch(user.updateIsDeceased(null));
            this.props.dispatch(user.updateIsOthers(null));
            this.props.setIsInitial(true);
        }

        this.setState({ isPopupSwitchBusinessIndividual: false });
    }

    toggleBusinessIndividual(isIndividualSelected) {

        const { t } = this.props;

        this.setState({
            isPopupSwitchBusinessIndividual: true,
            popupSwitchBusinessIndividual: {
                "title": isIndividualSelected ? t('zakat_switch_business') : t('zakat_switch_individual'),
            },
        });
    }

    setIRASAautoInclusion() {
        this.props.dispatch(user.updateIRASInclusion(!this.props.user.hasIRASInclusion));
        this.props.dispatch(zakatCalc.updateNisabValue(this.props?.homepage?.muisZakatHarta?.nisab?.value));
        // this.props.dispatch(user.resetUserFormData());
        // Only clear enrolment form data if user is not logged in
        if (!Boolean(loginPool.getCurrentUser())) {
            this.props.dispatch(user.resetUserFormData());
        }

        const dataObject = {
            rate: null,
            noOfPerson: 0,
            amount: 0
        };

        this.props.dispatch(zakat.updateZakatFitrahData('variable', dataObject));
        this.props.dispatch(zakat.resetFitrahData());
        this.props.dispatch(zakat.resetZakatData());
        this.props.dispatch(zakatCalc.resetZakatCalcData());

        this.setState({ variableRate: '', variableNoOfPeople: '' },
            () => this.shouldTriggerDisable()
        );

    }

    updateContext(errorExists) {

        let categories = [
            this.props.zakat.business,
            this.props.zakat.gold,
            this.props.zakat.insurance,
            this.props.zakat.savings,
            this.props.zakat.shares,
            this.props.zakat.zakatfitrah
        ]

        let finalAmount = 0;

        let invalidSection = categories.filter((element) => {

            if (element.type !== null && element.amount === 0) {
                return element
            } else if (element.rate !== 0 && element.people === 0) {
                return element
            }

        })

        categories.forEach((element) => {

            let basicTypes = [];

            if (element.name !== 'Zakat Fitrah') {
                if (Common.isValidField(element.type) && element.amount > config.DONATION_MIN_AMOUNT) {
                    basicTypes = invalidSection.filter(element => element.name !== 'Zakat Fitrah');
                    basicTypes.length === 0 ? this.setState({ isBtnDisabled: false }) : this.setState({ isBtnDisabled: true })
                } else if (Common.isValidField(element.type) && (element.amount === 0 || element.amount < config.DONATION_MIN_AMOUNT)) {
                    this.setState({ isBtnDisabled: true })
                }
            } else {
                if (errorExists === true) {
                    this.setState({ isBtnDisabled: true })
                } else if (errorExists === false) {
                    this.setState({ isBtnDisabled: false })
                }
            }

            finalAmount += parseFloat(element.amount === '.' ? 0 : element.amount || 0);
            finalAmount === 0 && this.setState({ isBtnDisabled: true });

        })

        this.setState({ totalAmt: finalAmount.toFixed(2) }, () => {
            let totalAmount = parseFloat(this.state.totalAmt).toFixed(2);
            this.props.dispatch(zakat.updateAmount(!isNaN(totalAmount) ? totalAmount : 0));
        })
    }

    getTypes(category) {
        let list = category.map(type => {
            let result = { label: type, value: type }
            return result;
        })
        return list;
    }

    getTransactionNo() {
        this.setState({ isLoading: true });
        document.getElementById('makepayment').setAttribute('disabled', true);

        const zakatHartaData = [
            this.props.zakat.business,
            this.props.zakat.gold,
            this.props.zakat.insurance,
            this.props.zakat.savings,
            this.props.zakat.shares,
        ];

        let sourceList = zakatHartaData.filter((item) => {

            // Need to bind additional condition as Fitrah's Key:Value pairs are not same as Harta's
            if (item.name !== 'Zakat Fitrah') {

                if (this.props.user.hasIRASInclusion == true) {
                    if (parseFloat(item.amount) > 0) {
                        return item;
                    }
                } else {
                    if (this.props.user.isBusinessPayer && item.name === 'Business') {
                        return item;
                    } else if (parseFloat(item.amount) > 0) {
                        return item;
                    }
                }
            } else {
                if (parseFloat(item.amount) > 0) {
                    return item;
                }
            }

        })

        // Create Array of Object based on necessary arguments required in payload for harta
        sourceList = sourceList.map((item) => Object({
            name: item.name,
            amount: parseFloat(parseFloat(item.amount).toFixed(2))
        }))

        let fitrah = [this.props.zakat.zakatfitrah.type.normal, this.props.zakat.zakatfitrah.type.premium, this.props.zakat.zakatfitrah.type.variable];
        let fitrahAmount = this.props.zakat.zakatfitrah.amount ?? 0;

        // Create Array of Object based on necessary arguments required in payload for fitrah
        if (fitrahAmount > 0) {
            fitrah = fitrah.filter((item) => {
                if (item.noOfPerson > 0 && item.amount > 0) {
                    item.name = item?.rate === this.props?.homepage?.muisZakatFitrah?.minAmount ? 'Normal'
                        : item?.rate === this.props?.homepage?.muisZakatFitrah?.maxAmount ? 'Premium'
                            : 'Variable';
                    return item;
                }
            });
        }

        // Store both array's destructured data in seperate file
        let muisHarta = [...sourceList]
        let muisFitrah = [...fitrah]

        let attributesObject = {};
        let appId = 0;

        if (sourceList.length > 0 && fitrahAmount > 0) {
            muisHarta = muisHarta.filter(item => item.name.trim() !== 'Zakat Fitrah');
            attributesObject = { muisHarta, muisFitrah }
            appId = this.state.zakatId;
        } else if (sourceList.length === 0 && fitrahAmount > 0) {
            attributesObject = { muisFitrah }
            appId = this.state.fitrahId;
        } else {
            muisHarta = muisHarta.filter(item => item.name.trim() !== 'Zakat Fitrah');
            attributesObject = { muisHarta }
            appId = this.state.zakatId;
        }

        let payload = {
            "charityId": config.MUIS_CHARITY_ID,
            "amount": parseFloat(this.props.zakat.totalAmount).toFixed(2),
            "currency": this.props.homepage.currencyCode ?? 'SGD',
            "hasIRASInclusion": this.props.user.hasIRASInclusion,
            "donationType": parseInt(appId),
            "isDeceased": this.props.user.isDeceased !== null ? this.props.user.isDeceased : false,
            "sourceOfIncome": this.props.user.isDeceased ? null : this.props.user.isBusinessPayer ? "Trade" : this.props.user.hasIRASInclusion ? this.props.zakat.sourceOfIncome : null,
            "attribute": JSON.stringify(attributesObject),
            "timeZone": Intl.DateTimeFormat().resolvedOptions().timeZone,
            "transactionNumber": this.props.user.transactionNo ?? null,
        }

        PayNow.getTransactionNumber(payload)
            .then((response) => {

                document.getElementById('makepayment').setAttribute('disabled', false);

                if (response.status === 1 && Common.isValidField(response.payNowResponse.transactionNumber)) {

                    const userData = {
                        ...this.props.user,
                        transactionNo: response.payNowResponse.transactionNumber,
                        iscalculatorFlow: false,
                        transactionType: 'zakat',
                        nextZakatDueDate: response.payNowResponse.nextZakatDueDate,
                        is3DSNeeded: false,
                        isAmountChanged: false,
                        trxCreationTime: Date.now(),
                    }

                    this.props.dispatch(user.updatePaymentData(userData));

                    if (this.props.zakat.zakatfitrah.type.variable.noOfPerson === 0) {
                        this.props.zakat.zakatfitrah.type.variable.rate = null;
                    }

                    this.props.history.push('/enrollment');

                    this.setState({ userData });
                } else {
                    this.setState({ isError: true, isBtnDisabled: false, isLoading: false });

                    this.props.dispatch(user.setApiError(true));

                    document.getElementById('makepayment').removeAttribute('disabled');
                }
            }).catch((error) => {
                this.setState({ isBtnDisabled: false, isLoading: false })
            });
    }

    setSources() {
        let sourceOfIncomes = this.props.homepage.muisZakatHarta?.sourceOfIncomes ?? [];

        // sourceOfIncomes = this.getTypes(sourceOfIncomes);

        const quickZakatArray = this.state.isBusinessPayer ? [{
            img: '',
            name: 'Business',
            amt: (this.state.reduxStore.business.amount ?? 0)
        }] : [{
            img: '',
            name: 'Savings',
            amt: (this.state.reduxStore.savings.amount ?? 0)
        },
        {
            img: '',
            name: 'Gold',
            amt: (this.state.reduxStore.gold.amount ?? 0)
        },
        {
            img: '',
            name: 'Insurance',
            amt: (this.state.reduxStore.insurance.amount ?? 0)
        },
        {
            img: '',
            name: 'Shares',
            amt: (this.state.reduxStore.shares.amount ?? 0)
        }];

        // Translation code
        const { t } = this.props;

        sourceOfIncomes = sourceOfIncomes.map((item) => this.sourceOfIncomeUpdate(item));

        sourceOfIncomes = this.getTypes(sourceOfIncomes);

        this.setState({
            types: quickZakatArray,
            sourceOfIncomeList: this.props.user.isBusinessPayer ? [{ label: t('Trade_label'), value: t('Trade_label') }] : sourceOfIncomes,
            ZakatFitrah:
            {
                isEnabled: this.props.user.isBusinessPayer ? false : Boolean(this.props.homepage?.muisZakatFitrah),
                img: '', name: 'Zakat Fitrah', rateSelected: (this.state.reduxStore.zakatfitrah.rate ?? this.props?.homepage?.muisZakatFitrah?.maxAmount ?? "0"),
                rateList: [
                    { label: CURRENCY_SYMBOL + '0', value: '0' },
                    { label: CURRENCY_SYMBOL + this.state.fitrahData?.minAmount, value: this.state.fitrahData?.minAmount },
                    { label: CURRENCY_SYMBOL + this.state.fitrahData?.maxAmount, value: this.state.fitrahData?.maxAmount },
                    { label: 'Variable', value: 'Variable' }
                ],
                noOfPerson: (this.state.reduxStore.zakatfitrah.people ?? null), amt: (this.state.reduxStore.zakatfitrah.amount ?? 0)
            },
        }, () => {
            if (this.props.user.isBusinessPayer) {
                this.props.dispatch(zakat.updateSourceOfIncome(t('Trade_label')));
            }
            // Commented code below as part of UAT Feedback bug fix - MUIS-
            // else {
            //     this.props.zakat.sourceOfIncome === 'Trade' && this.props.dispatch(zakat.updateSourceOfIncome(null))
            // }
        });

        let newZakatData = { ...this.props.zakat }

        Object.keys(this.props.zakat).forEach((field) => {
            if ((newZakatData[field]?.amount < minimumAmount || newZakatData[field]?.amount > MAX_OXPAY_ACCEPTANCE_AMOUNT) && field !== 'totalAmount') newZakatData = { ...newZakatData, [field]: { ...newZakatData[field], amount: 0 } }
            if (!newZakatData[field]?.amount && field !== 'totalAmount') newZakatData = { ...newZakatData, [field]: { ...newZakatData[field] } }
            if (!newZakatData[field]?.people && field === 'zakatfitrah') newZakatData = { ...newZakatData, [field]: { ...newZakatData[field], rate: 0 } }
        })
    }

    componentDidMount() {
        this._isMounted = true;

        const { t } = this.props;

        this.props.zakat.zakatfitrah.type.variable.rate = this.props.zakat.zakatfitrah.type.variable.rate <= this.props?.homepage?.muisZakatFitrah?.minAmount
            ? 0 : this.props.zakat.zakatfitrah.type.variable.rate;

        this.setState({ variableRate: this.props.zakat.zakatfitrah.type.variable.rate });

        this.setSources();

        i18n.on("languageChanged", () => {

            let sourceOfIncomes = this.props.homepage.muisZakatHarta?.sourceOfIncomes ?? [];

            sourceOfIncomes = sourceOfIncomes.map((item) => this.sourceOfIncomeUpdate(item));

            sourceOfIncomes = this.getTypes(sourceOfIncomes);

            this.setState({
                sourceOfIncomeList: this.props.user.isBusinessPayer ? [{ label: t('Trade_label'), value: t('Trade_label') }] : sourceOfIncomes,
            });

        });

        scrollTo();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (!isEqual(prevProps.zakat, this.props.zakat)) {
            const userData = {
                ...this.props.user,
                isAmountChanged: true,
            }
            this.props.dispatch(user.updatePaymentData(userData));
        }
    }

    sourceOfIncomeUpdate(value) {

        const { t } = this.props

        // eslint-disable-next-line default-case
        switch (true) {

            case String(value).includes('Employment'):
                return t('Source_of_income_employment');

            case String(value).includes('Others'):
                return t('Source_of_income_others');

            case String(value).includes('Dividend'):
                return t('Source_of_income_dividend');

            case String(value).includes('Rental'):
                return t('Source_of_income_rental');

            case String(value).includes('Trade'):
                return t('Trade_label');

            case String(value).includes('Interest'):
                return t('Source_of_income_interest');
        }
    }

    totalAmount(zakat) {
        let total = 0;
        Object.keys(zakat).forEach(val => {
            if (zakat[val]?.amount) total += parseInt(zakat[val]?.amount);
        })
        return total
    }

    closePopUP() {
        this.setState({ isError: false })
    }

    shouldComponentUpdate(newProps) {

        if (this.props.user.isBusinessPayer !== newProps.user.isBusinessPayer) {
            this.setState({
                isBusinessPayer: newProps.user.isBusinessPayer,
                isIRASAutoInclusionScheme: newProps.user.hasIRASInclusion === null ? true : false,
            }, () => setTimeout(() => this.setSources(), 0));
        }

        return true;
    }

    componentWillUnmount() {

        // Required to avoid Memory Leak of state when unmounting
        this._isMounted = false;

        // this.controller.abort();
    }

    closeIRASPopup() {
        this.setState({ isIRASAutoInclusionScheme: false, types: [] }, () => setTimeout(() => this.setSources(), 1));
    }

    updateFitrahData(data) {
        const rate = data?.rate === this.props?.homepage?.muisZakatFitrah?.minAmount ? 'normal'
            : data?.rate === this.props?.homepage?.muisZakatFitrah?.maxAmount ? 'premium'
                : 'variable';

        this.props.dispatch(zakat.updateZakatFitrahData(rate, data));
    }

    setFitrahData(type, floatValue) {
        const isNotNull = Boolean(floatValue);

        let dataObject = null;

        let rate = type === 'normal' ? this.props?.homepage?.muisZakatFitrah?.minAmount
            : type === 'premium' ? this.props?.homepage?.muisZakatFitrah?.maxAmount
                : this.state.variableRate;

        const Total = parseFloat(rate * floatValue).toFixed(2);

        dataObject = {
            rate: rate,
            noOfPerson: isNotNull ? floatValue : 0,
            amount: isNotNull ? Total : 0
        };

        this.updateFitrahData(dataObject);
    }

    shouldTriggerDisable(isFocus) {

        let result = false;

        result = !this.props.user.hasIRASInclusion ? false : !this.props.zakat.sourceOfIncome ? (isFocus ? true : false) : false;
        console.log(result, 'ressullt')
        this.setState({ renderIncomeError: result }, () => {

            const dataFields = document.getElementsByClassName('disabledField');

            for (const item of dataFields) {
                // result ? item.setAttribute('disabled', result) : item.removeAttribute('disabled');
            }

        });

        return result;
    }

    handleNext() {
        console.log('nexttcal')
        this.props.setHeaderData(enrollmentMethodHeaderData)
        this.props.dispatch(user.updateUserSteps(enrollmentMethodHeaderData));

        const zakatHartaData = [
            this.props.zakat.business,
            this.props.zakat.gold,
            this.props.zakat.insurance,
            this.props.zakat.savings,
            this.props.zakat.shares,
        ];

        let sourceList = zakatHartaData.filter((item) => {

            // Need to bind additional condition as Fitrah's Key:Value pairs are not same as Harta's
            if (item.name !== 'Zakat Fitrah') {

                if (this.props.user.hasIRASInclusion == true) {
                    if (parseFloat(item.amount) > 0) {
                        return item;
                    }
                } else {
                    if (this.props.user.isBusinessPayer && item.name === 'Business') {
                        return item;
                    } else if (parseFloat(item.amount) > 0) {
                        return item;
                    }
                }
            } else {
                if (parseFloat(item.amount) > 0) {
                    return item;
                }
            }

        })

        sourceList = sourceList.map((item) => Object({
            name: item.name,
            amount: parseFloat(parseFloat(item.amount).toFixed(2))
        }))

        let fitrah = [this.props.zakat.zakatfitrah.type.normal, this.props.zakat.zakatfitrah.type.premium, this.props.zakat.zakatfitrah.type.variable];
        let fitrahAmount = this.props.zakat.zakatfitrah.amount ?? 0;

        if (fitrahAmount > 0) {
            fitrah = fitrah.filter((item) => {
                if (item.noOfPerson > 0 && item.amount > 0) {
                    item.name = item?.rate === this.props?.homepage?.muisZakatFitrah?.minAmount ? 'Normal'
                        : item?.rate === this.props?.homepage?.muisZakatFitrah?.maxAmount ? 'Premium'
                            : 'Variable';
                    return item;
                }
            });
        }

        let muisHarta = [...sourceList]
        let muisFitrah = [...fitrah]

        let attributesObject = {};
        let appId = 0;

        if (sourceList.length > 0 && fitrahAmount > 0) {
            muisHarta = muisHarta.filter(item => item.name.trim() !== 'Zakat Fitrah');
            attributesObject = { muisHarta, muisFitrah }
            appId = this.state.zakatId;
        } else if (sourceList.length === 0 && fitrahAmount > 0) {
            attributesObject = { muisFitrah }
            appId = this.state.fitrahId;
        } else {
            muisHarta = muisHarta.filter(item => item.name.trim() !== 'Zakat Fitrah');
            attributesObject = { muisHarta }
            appId = this.state.zakatId;
        }

        let payload = {
            "charityId": config.MUIS_CHARITY_ID,
            "amount": parseFloat(this.props.zakat.totalAmount).toFixed(2),
            "currency": this.props.homepage.currencyCode ?? 'SGD',
            "hasIRASInclusion": this.props.user.hasIRASInclusion,
            "donationType": parseInt(appId),
            "isDeceased": this.props.user.isDeceased !== null ? this.props.user.isDeceased : false,
            "sourceOfIncome": this.props.user.isDeceased ? null : this.props.user.isBusinessPayer ? "Trade" : this.props.user.hasIRASInclusion ? this.props.zakat.sourceOfIncome : null,
            "attribute": JSON.stringify(attributesObject),
            "timeZone": Intl.DateTimeFormat().resolvedOptions().timeZone,
            "transactionNumber": this.props.user.transactionNo ?? null,
        }

        console.log(payload, 'initiatePayload')
        
    }

    handleSkip() {

    }

    toggleAccordion = (section) => {
        this.setState((prevState) => ({
          [section]: !prevState[section],
        }));
      }; 
        render() {
        console.log(this.state.renderIncomeError, 'renderIncomeError')
        const { fitrahOpen, hartaOpen } = this.state;
        const totalZakatAmount = (+this.props.zakat.gold.amount)+
        (+this.props.zakat.insurance.amount)+
        (+this.props.zakat.savings.amount)+
        (+this.props.zakat.shares.amount);
        const totalFitrahAmount = this.props.zakat.zakatfitrah.amount

        const { t } = this.props;
        let totalAmount = Number.isNaN(this.state.totalAmt) ? 0 : parseFloat(this.props.zakat.totalAmount).toFixed(2);
        let currentSOI = this.props.zakat.sourceOfIncome;

        switch (true) {
            case this.props.zakat.sourceOfIncome === 'Pekerjaan' || this.props.zakat.sourceOfIncome === 'Employment':
                currentSOI = t('Source_of_income_employment');
                break;

            case this.props.zakat.sourceOfIncome === 'Dividend' || this.props.zakat.sourceOfIncome === 'Dividen':
                currentSOI = t('Source_of_income_dividend');
                break;

            case this.props.zakat.sourceOfIncome === 'Rental' || this.props.zakat.sourceOfIncome === 'Sewa':
                currentSOI = t('Source_of_income_rental');
                break;

            case this.props.zakat.sourceOfIncome === 'Others' || this.props.zakat.sourceOfIncome === 'Yang lain':
                currentSOI = t('Source_of_income_others');
                break;

            case this.props.zakat.sourceOfIncome === 'Interest' || this.props.zakat.sourceOfIncome === 'Kadar faedah':
                currentSOI = t('Source_of_income_interest');
                break;

            case this.props.zakat.sourceOfIncome === 'Trade' || this.props.zakat.sourceOfIncome === 'Perdagangan':
                currentSOI = t('Trade_label');
                break;

            default:
                break;
        }


        return (
            <>
                <div className='flow-view'>
                     <div className='c-all-nisab-value'>
                        <p>
                             {t('Home_nisab_month_text')} :{' '} <span> {commaSeperatedAmount(CURRENCY_SYMBOL, parseFloat(this.props?.homepage?.muisZakatHarta?.nisab?.value).toFixed(2) ?? 0 )} ({moment().format('MMMM') + ' ' + moment().format('YYYY')}) </span> 
                        </p>
                    </div>
                    <>
                        {
                            this.state.reloadToSummary ? <Redirect to={{ pathname: '/enrollment' }} push={true} /> :
                                <>
                                    <div className='c-types'>

                                        {this.state.types.length > 0 ?
                                            <>
                                                <div className='c-business-iras'>

                                                    {/* {!this.props.user.isDeceased && !this.props.user.isOthers ? (
                                                        <div className='c-business-individual'>
                                                            <div className='c-iras-auto-inclusion'>
                                                                <div className='c-iras-tooltip'>
                                                                    <span>{t('Individual_label')}</span>
                                                                </div>
                                                                <div className='c-cus-slider'>
                                                                    <button
                                                                        type='button'
                                                                        className={'c-slider ' + (this.state.isBusinessPayer ? 'selected' : '')}
                                                                        onClick={() => this.toggleBusinessIndividual(!this.state.isBusinessPayer)}
                                                                    >
                                                                        <div className='circle'></div>
                                                                    </button>

                                                                </div>
                                                                <div className='c-iras-tooltip'>
                                                                    <span>{t('Business_label')}</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ) : null} */}
                                                    {!this.props.user.isDeceased && !this.props.user.isOthers ?
                                                    <div className='c-business-individual'>
                                                        <div className='c-cus-slider'>
                                                            <button
                                                                type='button'
                                                                onClick={() => {
                                                                    const isIndividualSelected = document.getElementById('individual-label').classList.contains('selected');
                                                                    this.toggleBusinessIndividual(isIndividualSelected)
                                                                }}
                                                                className='btn c-slider btn-transparent'>
                                                                <span id="individual-label" className={'lbl-individual ' + (this.state.isBusinessPayer ? '' : 'selected')}>{t('Individual_label')}</span>
                                                                <span className={'lbl-business ' + (this.state.isBusinessPayer ? 'selected' : '')}>{t('Business_label')}</span>
                                                            </button>
                                                        </div>
                                                    </div> : null
                                                }
                                                {
                                                    (this.props.user.hasIRASInclusion || this.props.user.isBusinessPayer) &&
                                                    <>
                                                        <form className='form c-source-of-income'>
                                                            <Select
                                                                name="sourceOfType"
                                                                id="sourceOfType"
                                                                styles={selectedStyles}
                                                                placeholder={t('Select_source_of_income')}
                                                                className={'select-form-control ' + (Boolean(this.props.zakat.sourceOfIncome) ? 'selected ' : (this.state.renderIncomeError ? 'is-invalid' : '')) + (Boolean(this.props.user.isBusinessPayer) ? 'disabled' : '')}
                                                                value={Boolean(currentSOI) ? { label: `${currentSOI}`, value: currentSOI } : ''}
                                                                options={this.state.sourceOfIncomeList}
                                                                isDisabled={Boolean(this.props.user.isBusinessPayer)}
                                                                isSearchable={false}
                                                                // maxMenuHeight={120}
                                                                onChange={(e) => {

                                                                    let soi = '';

                                                                    switch (true) {
                                                                        case e.value === 'Pekerjaan' || e.value === 'Employment':
                                                                            soi = t('Source_of_income_employment', { lng: 'en'});
                                                                            break;
                                                            
                                                                        case e.value === 'Dividend' || e.value === 'Dividen':
                                                                            soi = t('Source_of_income_dividend', { lng: 'en'});
                                                                            break;
                                                                        
                                                                        case e.value === 'Rental' || e.value === 'Sewa':
                                                                            soi = t('Source_of_income_rental', { lng: 'en'});
                                                                            break;
                                                            
                                                                        case e.value === 'Others' || e.value === 'Yang lain':
                                                                            soi = t('Source_of_income_others', { lng: 'en'});
                                                                            break;
                                                            
                                                                        case e.value === 'Interest' || e.value === 'Kadar faedah':
                                                                            soi = t('Source_of_income_interest', { lng: 'en'});
                                                                            break;
                                                                        
                                                                        case e.value === 'Trade' || e.value === 'Perdagangan':
                                                                            soi = t('Trade_label', { lng: 'en'});
                                                                            break;
                                                                    
                                                                        default:
                                                                            break;
                                                                    }

                                                                    this.props.dispatch(zakat.updateSourceOfIncome(soi));
                                                                    setTimeout(() => this.shouldTriggerDisable(),10);
                                                                }}
                                                            />
                                                            {
                                                                this.state.renderIncomeError && !Boolean(this.props.zakat.sourceOfIncome) 
                                                                ? <span className="invalid-feedback error">{t('please_select_source_of_income')}</span>
                                                                : null
                                                            }
                                                        </form>
                                                    </>
                                                }

                                                </div>
                                                <div className='c-harta-fitrah'>
                                                    {this.props?.homepage?.muisZakatFitrah && !this.props.user.isBusinessPayer && !this.props.user.isDeceased ?
                                                            <div className={`harta-fitrah-accordion c-zakat-fitrah ${fitrahOpen ? 'open' : ''}`}>
                                                                <div className='accordion-button'  onClick={() => this.toggleAccordion('fitrahOpen')}>
                                                                    <h3 className='title'>{t('Zakat_fitrah_label')}:  <span>{commaSeperatedAmount(CURRENCY_SYMBOL, String(totalFitrahAmount))}</span> </h3> 
                                                                    <button className='btn btn-transparent'> {fitrahOpen ? <> {ACCORDION_TOP}</>  : <>{ACCORDION_BOTTOM} </> }</button>
                                                                </div>
                                                                <div className="accordion-content">
                                                                    <Formik enableReinitialize={true} validateOnBlur={true} validateOnChange={true} >
                                                                        {({ errors, values, setFieldValue }) => (
                                                                            <Form className="form">
                                                                                <div className={'row ' + (this.props.zakat.zakatfitrah.type.normal.noOfPerson > 0 ? 'selected' : '')}>
                                                                                    <div className='col-lg-12 col-md-12 col-xs-12 col-xs-12 col-rate'>
                                                                                        <label className='col-cust-label'>{t('Normal_rate_label')} :</label>
                                                                                        <p className='c-text'>&nbsp;( {Common.intlNumberFormat(this.props?.homepage?.muisZakatFitrah?.minAmount ?? 0)} )</p>
                                                                                    </div>
                                                                                    <div className='col-md-6 col-sm-6 col-xs-6  col-no-of-people'>
                                                                                        <label className='cust-label'>{t('No_of_people_label')}</label>
                                                                                        <NumberFormat
                                                                                            inputMode="decimal"
                                                                                            placeholder="0"
                                                                                            maxLength={7}
                                                                                            allowNegative={false}
                                                                                            name="noOfPerson"
                                                                                            id="noOfPerson"
                                                                                            className={"disabledField form-control"}
                                                                                            allowLeadingZeros={false}
                                                                                            onFocus={() => this.shouldTriggerDisable(true)}
                                                                                            value={this.props.zakat.zakatfitrah.type.normal.noOfPerson > 0 ? this.props.zakat.zakatfitrah.type.normal.noOfPerson : ""}
                                                                                            displayType={"input"}
                                                                                            decimalScale={0}
                                                                                            thousandSeparator={true}
                                                                                            onValueChange={({ floatValue }) => this.setFitrahData('normal', floatValue)}
                                                                                        />
                                                                                    </div>
                                                                                    <div className='col-md-6 col-sm-6 col-xs-6 col-amount'>
                                                                                        <label className='cust-label'>{t('Amount_label')}</label>
                                                                                        <NumberFormat
                                                                                            inputMode="decimal"
                                                                                            placeholder="$0.00"
                                                                                            value={this.props.zakat.zakatfitrah.type.normal.amount ? parseFloat(this.props.zakat.zakatfitrah.type.normal.amount).toFixed(2) : ''}
                                                                                            maxLength={8}
                                                                                            name="amount"
                                                                                            id="amount"
                                                                                            allowLeadingZeros={false}
                                                                                            className={
                                                                                                "form-control " +
                                                                                                (errors.noOfPerson ? "is-invalid" : "")
                                                                                            }
                                                                                            displayType={"input"}
                                                                                            thousandSeparator={true}
                                                                                            prefix={"$"}
                                                                                            disabled
                                                                                        />
                                                                                        {errors.noOfPerson && (
                                                                                            <span className="invalid-feedback error">
                                                                                                {errors.noOfPerson}
                                                                                            </span>
                                                                                        )}
                                                                                    </div>
                                                                                </div>
                                                                                <div className={'row ' + (this.props.zakat.zakatfitrah.type.premium.noOfPerson > 0 ? 'selected' : '')}>
                                                                                    <div className='col-lg-12 col-md-12 col-xs-12 col-xs-12 col-rate'>
                                                                                        <label className='col-cust-label'>{t('Premium_rate_label')} : </label>
                                                                                        <p className='c-text'>&nbsp;({Common.intlNumberFormat(this.props?.homepage?.muisZakatFitrah?.maxAmount ?? 0)})</p>
                                                                                    </div>
                                                                                    <div className='col-md-6 col-sm-6 col-xs-6 col-no-of-people'>
                                                                                        <label className='cust-label'>{t('No_of_people_label')}</label>
                                                                                        <NumberFormat
                                                                                            inputMode="decimal"
                                                                                            placeholder="0"
                                                                                            maxLength={7}
                                                                                            allowNegative={false}
                                                                                            name="noOfPerson"
                                                                                            id="noOfPerson"
                                                                                            className={"disabledField form-control"}
                                                                                            allowLeadingZeros={false}
                                                                                            onFocus={() => this.shouldTriggerDisable(true)}
                                                                                            value={this.props.zakat.zakatfitrah.type.premium.noOfPerson > 0 ? this.props.zakat.zakatfitrah.type.premium.noOfPerson : ""}
                                                                                            displayType={"input"}
                                                                                            decimalScale={0}
                                                                                            thousandSeparator={true}
                                                                                            onValueChange={({ floatValue }) => this.setFitrahData('premium', floatValue)}
                                                                                        />
                                                                                    </div>
                                                                                    <div className='col-md-6 col-sm-6 col-xs-6 col-amount'>
                                                                                        <label className='cust-label'>{t('Amount_label')}</label>
                                                                                        <NumberFormat
                                                                                            inputMode="decimal"
                                                                                            placeholder="$0.00"
                                                                                            value={this.props.zakat.zakatfitrah.type.premium.amount ? parseFloat(this.props.zakat.zakatfitrah.type.premium.amount).toFixed(2) : ''}
                                                                                            maxLength={8}
                                                                                            name="amount"
                                                                                            id="amount"
                                                                                            allowLeadingZeros={false}
                                                                                            className={
                                                                                                "form-control " +
                                                                                                (errors.noOfPerson ? "is-invalid" : "")
                                                                                            }
                                                                                            displayType={"input"}
                                                                                            thousandSeparator={true}
                                                                                            prefix={"$"}
                                                                                            disabled
                                                                                        />
                                                                                        {errors.noOfPerson && (
                                                                                            <span className="invalid-feedback error">
                                                                                                {errors.noOfPerson}
                                                                                            </span>
                                                                                        )}
                                                                                    </div>
                                                                                </div>
                                                                                <div className='row'>
                                                                                    <div className='col-lg-12 col-md-12 col-xs-12 col-xs-12 col-rate'>
                                                                                        <label className='col-cust-label'>{t('Variable_rate_label')}</label>
                                                                                    </div>
                                                                                    <div className='col-md-12 col-sm-12 col-xs-12 col-rate-box'>
                                                                                        <label className='cust-label'>Rate</label>
                                                                                        <NumberFormat
                                                                                            inputMode="decimal"
                                                                                            placeholder="0"
                                                                                            maxLength={8}
                                                                                            allowNegative={false}
                                                                                            className={"disabledField form-control"}
                                                                                            allowLeadingZeros={false}
                                                                                            displayType={"input"}
                                                                                            decimalScale={2}
                                                                                            prefix={"$"}
                                                                                            value={this.state.variableRate > 0 ? this.state.variableRate : ''}
                                                                                            onFocus={() => this.shouldTriggerDisable(true)}
                                                                                            thousandSeparator={true}
                                                                                            onValueChange={({ floatValue, value }) => {

                                                                                                this.setState({ variableRate: floatValue }, () => {

                                                                                                    if (value && value.length > 0) {

                                                                                                        if (floatValue <= Number(this.props?.homepage?.muisZakatFitrah?.minAmount)) {
                                                                                                            document.getElementById('variableNoOfPeople').setAttribute('disabled', true);
                                                                                                            this.setState({ variableNoOfPeople: '', variableError: t('Variable_rate_max_error') },
                                                                                                                () => this.setFitrahData('variable', 0))
                                                                                                        } else {
                                                                                                            this.setState({ variableError: "" }, () => this.setFitrahData('variable', this.state.variableNoOfPeople ?? 0))
                                                                                                            document.getElementById('variableNoOfPeople').removeAttribute('disabled');
                                                                                                        }

                                                                                                    } else {
                                                                                                        this.setState({ variableError: "", variableNoOfPeople: '' }, () => this.setFitrahData('variable', 0));
                                                                                                        document.getElementById('variableNoOfPeople').setAttribute('disabled', true);
                                                                                                    }
                                                                                                })
                                                                                            }}
                                                                                        />
                                                                                    </div>
                                                                                    <div className='col-md-6 col-sm-6 col-xs-6 col-no-of-people'>
                                                                                        <label className='cust-label'>{t('No_of_people_label')}</label>
                                                                                        <NumberFormat
                                                                                            placeholder="0"
                                                                                            inputMode="decimal"
                                                                                            maxLength={7}
                                                                                            allowNegative={false}
                                                                                            id="variableNoOfPeople"
                                                                                            name="variableNoOfPeople"
                                                                                            className={"form-control"}
                                                                                            allowLeadingZeros={false}
                                                                                            value={this.state.variableNoOfPeople}
                                                                                            displayType={"input"}
                                                                                            decimalScale={0}
                                                                                            disabled={!Boolean(this.state.variableRate)}
                                                                                            thousandSeparator={true}
                                                                                            onValueChange={({ floatValue }) => {
                                                                                                if (floatValue > 0) {
                                                                                                    this.setState({ variableNoOfPeople: floatValue })
                                                                                                } else {
                                                                                                    this.setState({ variableNoOfPeople: '' })
                                                                                                }
                                                                                                this.setFitrahData('variable', floatValue > 0 ? floatValue : 0);
                                                                                            }}
                                                                                        />
                                                                                    </div>
                                                                                    <div className='col-md-6 col-sm-6 col-xs-6 col-amount'>
                                                                                        <label className='cust-label'>{t('Amount_label')}</label>
                                                                                        <NumberFormat
                                                                                            placeholder="$0.00"
                                                                                            inputMode="decimal"
                                                                                            value={this.props.zakat.zakatfitrah.type.variable.amount ? parseFloat(this.props.zakat.zakatfitrah.type.variable.amount).toFixed(2) : ''}
                                                                                            maxLength={8}
                                                                                            name="amount"
                                                                                            id="amount"
                                                                                            allowLeadingZeros={false}
                                                                                            className={
                                                                                                "form-control " +
                                                                                                (errors.noOfPerson ? "is-invalid " : parseFloat(this.props.zakat.zakatfitrah.type.variable.amount) > 0 ? 'c-g ' : '')
                                                                                            }
                                                                                            displayType={"input"}
                                                                                            thousandSeparator={true}
                                                                                            prefix={"$"}
                                                                                            disabled
                                                                                        />
                                                                                        {errors.noOfPerson && (
                                                                                            <span className="invalid-feedback error">
                                                                                                {errors.noOfPerson}
                                                                                            </span>
                                                                                        )}
                                                                                    </div>
                                                                                </div>
                                                                                <div className='row'>
                                                                                    <div className='col-xs-12' style={{ minHeight: 'auto' }}>
                                                                                        {this.state.variableError && <span className='invalid-feedback'>{t('Variable_rate_max_error')}</span>}
                                                                                    </div>
                                                                                </div>
                                                                            </Form>
                                                                        )}
                                                                    </Formik>
                                                                </div>
                                                            </div>
                                                    : null}
                                                    
                                                    <div className={'harta-fitrah-accordion mb-0 c-zakat-harta  ' + ((Boolean(this.props.user.isBusinessPayer) || Boolean(this.props.user.isDeceased)) ? 'no-accordion ': ''  ) + (hartaOpen ? 'open' : ' ') + (this.props?.homepage?.muisZakatFitrah && Boolean(!this.props.user.isBusinessPayer) && !this.props.user.isDeceased ? '' : 'only-harta ') + (Boolean(this.props.user.isBusinessPayer) ? 'only-business open ' : '') + (Boolean(this.props.user.isDeceased) ? ' only-deceased open ' : '')}>
                                                        <div className={`accordion-button ${(Boolean(this.props.user.isBusinessPayer) || Boolean(this.props.user.isDeceased)) ? 'd-none': ''  }`} onClick={() => this.toggleAccordion('hartaOpen')} >
                                                            <h3 className='title'>{t('Zakat_harta_label')}:   <span>{commaSeperatedAmount(CURRENCY_SYMBOL, totalZakatAmount)
                                                            }</span> </h3>
                                                            <button className='btn btn-transparent'>{hartaOpen ? <> {ACCORDION_TOP}</>  : <>{ACCORDION_BOTTOM} </> }</button>
                                                        </div>
                                                        <div className="accordion-content">
                                                            <div className='c-body'>
                                                                {
                                                                    Array.from([...this.state.types])
                                                                        .map((type, index) => (
                                                                            <Type
                                                                                type={type}
                                                                                key={index}
                                                                                inputRef={(el) => this.inputRefs[index] = el} // Add ref assignment
                                                                                nextInputRef={() => this.inputRefs[index + 1]} // For next input
                                                                                updateContext={this.updateContext}
                                                                                shouldDisableField={this.shouldTriggerDisable}
                                                                                totalData={this.state.totalAmt}
                                                                            />
                                                                        ))
                                                                }
                                                            </div>
                                                        </div> 
                                                    </div> 
                                                </div>
                                            </>
                                            :
                                            <FlickeringTypeOfZakat types={this.state.types} />
                                        }

                                        <div className='c-btn-note'>
                                            {(totalAmount > MAX_OXPAY_ACCEPTANCE_AMOUNT) ? <span className="error">{`${t('Errors_total_amount')} $${MAX_OXPAY_ACCEPTANCE_AMOUNT}`}</span> : null}
                                        </div>
                                    </div>
                                    {
                                        this.state.isLoading ?
                                            <div className='c-loader'><Loader /></div> : null
                                    }
                                </>
                        }
                        {this.state.isPopupSwitchBusinessIndividual ?
                            <PopupSwitchBusinessIndividual data={this.state.popupSwitchBusinessIndividual} handleClose={this.handleCloseBusinessIndividual} handleOkay={this.handleOkayBusinessIndividual} />
                            : null
                        }
                    </>
                </div>
                <Footer setHeaderData={this.props.setHeaderData} isSkipButtonVisible={false} handleNext={this.handleNext} handleSkip={this.handleSkip} disabled={(totalAmount < config.DONATION_MIN_AMOUNT || totalAmount > MAX_OXPAY_ACCEPTANCE_AMOUNT ||(this.state.renderIncomeError && !Boolean(this.props.zakat.sourceOfIncome)))} totalPayable={totalAmount}  />
            </>
        )
    }
}

function mapStateToProps(state) {
    return {
        zakat: state.zakatReducer,
        homepage: state.homepageReducer,
        user: state.userReducer,
    }
}
export default withRouter(connect(mapStateToProps)(withTranslation()(TypeOfZakat)))